import { PaymentVersion } from './payment-version.entity';

const _numbFive = 5;

export class Payments {
    public payroll_attributes = [];
    public invoice_attributes = [];
    public versions: Array<PaymentVersion> = [];


    fromJSON(type: string, data: any) {
        if (type === 'version') {
            this.versions = [];
            for (let version_attributr of data) {
                let version = new PaymentVersion();
                version.model = version_attributr.model;
                version.change_set = version_attributr.changeset;
                version.booking_event = version_attributr.event;
                version.created_at_iso = new Date(version_attributr.created_at).toISOString();
                version.first_name = version_attributr.first_name;
                version.last_name = version_attributr.last_name;
                version.photo_url = version_attributr.photo_url;
                version.object_id = version_attributr.object_id;
                this.versions.push(version);
            };
        } else {
            data.forEach(payrollInvoice => {
                payrollInvoice.interpreting_time = this.minutesToTime(payrollInvoice.interpreting_time);
                payrollInvoice.interpreting_time_night = this.minutesToTime(payrollInvoice.interpreting_time_night);
                payrollInvoice.interpreting_time_weekend = this.minutesToTime(payrollInvoice.interpreting_time_weekend);
                payrollInvoice.preparation_time = this.minutesToTime(payrollInvoice.preparation_time);
                payrollInvoice.travel_time = this.minutesToTime(payrollInvoice.travel_time);
                payrollInvoice.distance = this.meterToKm(payrollInvoice.distance);
                payrollInvoice.recommended.travel_time = this.minutesToTime(payrollInvoice.recommended.travel_time);
                payrollInvoice.recommended.distance = this.meterToKm(payrollInvoice.recommended.distance);
                payrollInvoice.recommended.interpreting_time = this.minutesToTime(payrollInvoice.recommended.interpreting_time);
                payrollInvoice.recommended.interpreting_time_night = this.minutesToTime(payrollInvoice.recommended.interpreting_time_night);
                payrollInvoice.recommended.interpreting_time_weekend = this.minutesToTime(payrollInvoice.recommended.interpreting_time_weekend);

                if (type === 'payroll') {
                    this.payroll_attributes.push(payrollInvoice);
                } else {
                    this.invoice_attributes.push(payrollInvoice);
                }
            });
        }
    }

    createJSON() {
        let o = new Object({
                payroll_attributes: this.timeDistanceConversion(JSON.stringify(this.payroll_attributes)),
                invoice_attributes: this.timeDistanceConversion(JSON.stringify(this.invoice_attributes))
        });
        return o;
    }

    minutesToTime(minutes: string) {
        let min = +minutes;
        let hours = Math.floor(min / 60);
        let remainingMinutes = this.roundOffMinutes(min % 60).toString();
        return hours + ':' + (remainingMinutes.length === 1 ? '0' + remainingMinutes : remainingMinutes);
    }

    roundOffMinutes(minutes: number) {
        return Math.ceil(minutes / _numbFive) * _numbFive;
    }

    timeDistanceConversion(data: any) {
        let billing_attributes = [];

        JSON.parse(data).forEach(payrollInvoice => {
            payrollInvoice.interpreting_time = this.convertToMinutes(payrollInvoice.interpreting_time);
            payrollInvoice.interpreting_time_night = this.convertToMinutes(payrollInvoice.interpreting_time_night);
            payrollInvoice.interpreting_time_weekend = this.convertToMinutes(payrollInvoice.interpreting_time_weekend);
            payrollInvoice.preparation_time = this.convertToMinutes(payrollInvoice.preparation_time);
            payrollInvoice.travel_time = this.convertToMinutes(payrollInvoice.travel_time);
            payrollInvoice.distance = this.kmToMeter(payrollInvoice.distance);
            payrollInvoice.recommended.travel_time = this.convertToMinutes(payrollInvoice.recommended.travel_time);
            payrollInvoice.recommended.distance = this.kmToMeter(payrollInvoice.recommended.distance);
            payrollInvoice.recommended.interpreting_time = this.convertToMinutes(payrollInvoice.recommended.interpreting_time);
            payrollInvoice.recommended.interpreting_time_night = this.convertToMinutes(payrollInvoice.recommended.interpreting_time_night);
            payrollInvoice.recommended.interpreting_time_weekend = this.convertToMinutes(payrollInvoice.recommended.interpreting_time_weekend);

            billing_attributes.push(payrollInvoice);
        });

        return billing_attributes;
    }

    meterToKm(meters: string) {
        return (meters === '0.0') ? 0 : Math.round((+meters / 1000));
    }

    kmToMeter(km: string) {
        if (km === '0.0') {
            return km;
        } else {
            return (+km * 1000);
        }
    }

    convertToMinutes(time) {
        if (time.toString() === '0') {
            return time;
        }
        if (time.indexOf(':') !== -1) {
            let split = time.split(':');
            let hours = split[0];
            let minutes = split[1];
            return (+hours * 60 + +minutes).toString();
        } else {
            return time;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/payment.entity.ts